import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import LetterTile from './letter_tile';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function LetterRow({index}) {
  const classes = useStyles();

  /*
  <Grid item xs={3}>
        <LetterTile index={index} />
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 1}/>
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 2}/>
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 3}/>
      </Grid>
  */

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item xs={3}>
        <LetterTile index={index} />
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 1}/>
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 2}/>
      </Grid>
      <Grid item xs={3}>
        <LetterTile index={index + 3}/>
      </Grid>
    </Grid>
  );
};
